// extracted by mini-css-extract-plugin
module.exports = {"d2x-fix-tab":"FixTab_d2x-fix-tab__JLLy4"};